export const LANG_MAP = {
  "es-cl": "es",
  "en-us": "en",
}

export function getLangFromPageContext(pageContext) {
  const pageLang = pageContext?.lang || "es-cl"
  return LANG_MAP[pageLang] || "es"
}

export function getUrlPrefix(lang) {
  return lang && lang !== "es" ? `/${lang}` : ""
}
